export default __webpack_public_path__ + "static/custom-marker-shapes-e0d13db11ad597bbd0796004e1485f3a.png";